@if (signaalkaart$ | async; as signaalkaart) {
  @if (client$ | async; as client) {
    @if (dienstId$ | async; as dienstId) {
      <zah-signaalkaart-header [signaalkaart]="signaalkaart"
        [client]="client">
      </zah-signaalkaart-header>
      <div class="content">
        <zah-signaalkaart [signaalkaart]="signaalkaart"
          (cancelClicked)="navigateBack()"
          (okClicked)="bewaarSignaalkaartAntwoord($event, client.getId(), dienstId)">
        </zah-signaalkaart>
      </div>
    }
  }
}
